var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'form-input-length-counter',
    {
      'form-input-length-counter--exceeded': _vm.isExceeded
    }
  ]},[_c('div',{staticClass:"form-input-length-counter__counter"},[_vm._v(_vm._s(_vm.counterText))]),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"form-input-length-counter__label",style:(_vm.labelStyles)},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentLabel)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }